import { useEffect } from "react";
import Button from "@mui/material/Button";
import ModalHeader from "src/components/general/Modal/components/ModalHeader/ModalHeader";
import Modal from "src/components/general/Modal/Modal";
import GenerateTokenFormContent from "./components/GenerateTokenFormContent/GenerateTokenFormContent";
import { useGenerateTokenForm } from "./GenerateTokenForm.hooks";

interface GenerateTokenFormProps {
  open: boolean;
  onClose: () => void;
}

export default function GenerateTokenForm({
  open,
  onClose,
}: GenerateTokenFormProps) {
  const {
    tokenType,
    setTokenType,
    label,
    setLabel,
    expiresInDays,
    setExpiresInDays,
    readOnly,
    setReadOnly,
    generatedToken,
    typeLabel,
    createMutation,
    handleCreate,
    reset,
  } = useGenerateTokenForm();

  useEffect(() => {
    if (open) {
      reset();
    }
  }, [open, reset]);

  return (
    <Modal isOpen={open} onClose={onClose} size="fit" testId="generate-token-dialog">
      <ModalHeader
        title={generatedToken ? "Token Created" : `Generate ${typeLabel} Token`}
        onClose={onClose}
      />
      <div className="flex w-[37.5rem] flex-col gap-4 p-6">
        <GenerateTokenFormContent
          generatedToken={generatedToken}
          typeLabel={typeLabel}
          tokenType={tokenType}
          onTokenTypeChange={setTokenType}
          label={label}
          onLabelChange={setLabel}
          expiresInDays={expiresInDays}
          onExpiresInDaysChange={setExpiresInDays}
          readOnly={readOnly}
          onReadOnlyChange={setReadOnly}
        />
      </div>
      <div className="flex justify-end gap-2 px-6 pb-6">
        <Button onClick={onClose}>{generatedToken ? "Done" : "Cancel"}</Button>
        {!generatedToken && (
          <Button
            variant="contained"
            onClick={() => void handleCreate()}
            disabled={createMutation.isPending}
          >
            {createMutation.isPending ? "Generating…" : "Generate"}
          </Button>
        )}
      </div>
    </Modal>
  );
}
